module.exports = __webpack_public_path__ + "static/media/themify.cba68f98.svg";